import Vue from 'vue';
import Vuex from 'vuex';
// If needed to use route on store
// import router from './router';

/*
Axios template to create api variable
  const $http = axios.create({
    baseURL: process.env.VUE_APP_API_URL
  });
*/

// ** store.js should be used for GLOBAL state only
// ** for specific page related state add a module file on the modules folder and import it

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cardInfo: {
      info1: {
        img: 'illust2',
        title: 'Staff Augmentation',
        text:
          'We find and place the right skilled people from our talent pool into your project.',
        modalText:
          'Based on your requirements, we find and place the right skilled people from our talent pool into your project.<br><br>Our talent network includes experienced professionals working in software engineering (mobile, back end, front end and fullstack), software quality assurance, devops, database management, UX / UI design and project management. In this business model, you are the owner of the team.'
      },
      info2: {
        img: 'illust3',
        title: 'Managed Teams',
        text:
          'We build teams to handle specific requirements outlined in a Statement of Work(SOW).',
        modalText:
          'Our Managed Teams solution is designed to handle specific requirements outlined in a Statement of Work (SOW), allowing you to focus on more strategic programs, and also freeing your team to focus on your core projects and competencies.<br><br>We partner with you to manage your resources, and our success is measured on agreed defined deliverables.'
      },
      info3: {
        img: 'illust4',
        title: 'Product Engineering',
        text: 'We tailor product solutions to your ideas and business needs.',
        modalText:
          'We build teams to help you land and tailor product solutions to your business needs. From Proof of Concept and Prototypes, to the creation of web and/or mobile applications.'
      }
    }
  },
  mutations: {},
  actions: {
    async SEND_EMAIL(context, data = null) {
      try {
        const callable = Vue.firebaseFunctions.httpsCallable('sendEmail');
        if (data !== null) {
          return callable(data);
        }
      } catch (err) {
        console.log('Email err', err);
        return err;
      }
    }
  },
  getters: {
    GET_CARDS: state => state.cardInfo,
    GET_CARD: state => id => state.cardInfo[id]
  }
});
